var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.4444V10H10V30H30V14.4444H20ZM14 27.7778H12V25.5556H14V27.7778ZM14 23.3333H12V21.1111H14V23.3333ZM14 18.8889H12V16.6667H14V18.8889ZM14 14.4444H12V12.2222H14V14.4444ZM18 27.7778H16V25.5556H18V27.7778ZM18 23.3333H16V21.1111H18V23.3333ZM18 18.8889H16V16.6667H18V18.8889ZM18 14.4444H16V12.2222H18V14.4444ZM28 27.7778H20V25.5556H22V23.3333H20V21.1111H22V18.8889H20V16.6667H28V27.7778ZM26 18.8889H24V21.1111H26V18.8889ZM26 23.3333H24V25.5556H26V23.3333Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconBuilding);
export default __webpack_public_path__ + "static/media/TH-Icon-Building.38d62982b30f8c6fbbf106ab8f4b6d7a.svg";
export { ForwardRef as ReactComponent };